import React from 'react';
import { Button, Col, Modal, CardBody, Row } from 'reactstrap';

export const ModalDelete = (props) => {
  return (
    <Modal
      isOpen={props.isOpen}
      toggle={() => {
        props.toggle();
      }}
      centered
      id="zoomIn"
      zIndex={10000}
      backdrop={'static'}
      modalClassName="zoomIn"
    >
      <Col lg={12}>
        <CardBody className="p-5">
          <Col className="text-center mb-2">
            <lord-icon
              src="https://cdn.lordicon.com/tntmaygd.json"
              trigger="loop"
              colors="primary:#dc3545,secondary:#dc3545"
              style={{ width: '120px', height: '120px' }}
            ></lord-icon>
          </Col>

          <Row className="text-center">
            <h4 className="mb-3">Deseja excluir?</h4>
            <p className="text-muted mb-4">Tem certeza que deseja excluir?</p>
          </Row>

          <Row className="d-flex justify-content-center" lg={6}>
            <Col xs={3} md={3} lg={3}>
              <button
                type="button"
                className="btn btn-link"
                onClick={() => props.goBack()}
              >
                Cancelar
              </button>
            </Col>
            <Col xs={3} md={3} lg={3}>
              <Button
                type="button"
                className="btn btn-danger"
                onClick={() => props.handleDelete()}
              >
                Excluir
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Col>
    </Modal>
  );
};
